<div class="page-title-right">
  <ol class="breadcrumb m-0">
    <li class="breadcrumb-item"><a routerLink="/admin/bio">Bio</a></li>
    <li class="breadcrumb-item active">Aparência</li>
  </ol>
</div>

<h4 class="page-title">
  <i class="fas fa-palette mr-2"></i>
  MeuCardápio Bio - Aparência
</h4>

<div class="text-center p-5" *ngIf="carregando">
  <div class="k-i-loading" style="font-size: 40px;"></div>
</div>

<!-- Sem Bio Page -->
<div class="card" *ngIf="!carregando && !bioPagina">
  <div class="card-body text-center p-5">
    <i class="fas fa-palette fa-3x text-muted mb-3"></i>
    <p class="text-muted">Configure primeiro a página Bio em "Configurações" antes de personalizar a aparência.</p>
    <a routerLink="/admin/bio/configuracoes" class="btn btn-primary">
      <i class="fas fa-cog mr-1"></i> Ir para Configurações
    </a>
  </div>
</div>

<!-- Layout Split: Controles + Preview -->
<div class="aparencia-layout" [ngClass]="{'controles-hidden': !mostrarControles}" *ngIf="!carregando && bioPagina">
  <!-- Coluna esquerda: Controles -->
  <div class="controles-panel" *ngIf="mostrarControles">

    <!-- Banner de alterações não salvas -->
    <div class="unsaved-banner" *ngIf="temAlteracoesPendentes">
      <div class="unsaved-banner-content">
        <i class="fas fa-exclamation-triangle"></i>
        <span>Você tem alterações não salvas</span>
      </div>
      <div class="unsaved-banner-actions">
        <button class="btn btn-sm btn-success" (click)="salvar()" [disabled]="salvando">
          <i class="fas fa-save mr-1"></i> Salvar
        </button>
        <button class="btn btn-sm btn-outline-secondary" (click)="resetar()">
          Descartar
        </button>
      </div>
    </div>

    <!-- Paletas Pré-definidas -->
    <div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title mb-3">
          <i class="fas fa-swatchbook text-primary mr-2"></i>
          Paletas Pré-definidas
        </h5>
        <div class="paletas-scroll">
          <div class="paletas-grid">
            <div class="paleta-card"
                 *ngFor="let paleta of paletasPreDefinidas; let i = index"
                 [ngClass]="{'paleta-selecionada': paletaSelecionadaIndex === i}"
                 (click)="aplicarPaleta(i)">
              <div class="paleta-info">
                <span class="paleta-emoji">{{paleta.emoji}}</span>
                <span class="paleta-nome">{{paleta.nome}}</span>
              </div>
              <div class="paleta-swatches">
                <span class="paleta-swatch" [style.backgroundColor]="paleta.corPrimaria"></span>
                <span class="paleta-swatch" [style.backgroundColor]="paleta.corSecundaria"></span>
                <span class="paleta-swatch" [style.backgroundColor]="paleta.corFundo"></span>
                <span class="paleta-swatch" [style.backgroundColor]="paleta.corFundoCard"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Cores -->
    <div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title mb-3">
          <i class="fas fa-palette text-primary mr-2"></i>
          Cores
        </h5>

        <div class="color-grid">
          <!-- Cor Primária -->
          <div class="color-control">
            <label class="font-weight-bold">Cor Primária</label>
            <div class="mt-2">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corPrimaria" [format]="'hex'"
                                 (valueChange)="deselecionarPaleta(); enviarParaPreview()"></kendo-colorpicker>
            </div>
            <small class="form-text text-muted mt-2">Botões, destaques e CTA</small>
          </div>

          <!-- Cor do Botão CTA -->
          <div class="color-control">
            <label class="font-weight-bold">Cor do Botão CTA</label>
            <div class="mt-2">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corBotaoCta" [format]="'hex'"
                                 (valueChange)="deselecionarPaleta(); enviarParaPreview()"></kendo-colorpicker>
            </div>
            <small class="form-text text-muted mt-2">Botão 'Pedir Agora' nas ofertas</small>
          </div>

          <!-- Cor Secundária -->
          <div class="color-control">
            <label class="font-weight-bold">Cor Secundária</label>
            <div class="mt-2">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corSecundaria" [format]="'hex'"
                                 (valueChange)="deselecionarPaleta(); enviarParaPreview()"></kendo-colorpicker>
            </div>
            <small class="form-text text-muted mt-2">Textos e subtítulos</small>
          </div>

          <!-- Cor de Fundo -->
          <div class="color-control">
            <label class="font-weight-bold">Cor de Fundo</label>
            <div class="mt-2">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corFundo" [format]="'hex'"
                                 (valueChange)="deselecionarPaleta(); atualizarCorTextoAuto(); enviarParaPreview()"></kendo-colorpicker>
            </div>
            <small class="form-text text-muted mt-2">Background da página</small>
          </div>

          <!-- Cor do Texto -->
          <div class="color-control" [ngClass]="{'cor-texto-auto': corTextoAuto}">
            <label class="font-weight-bold">Cor do Texto</label>
            <div class="mt-2 d-flex align-items-center">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corTexto" [format]="'hex'"
                                 [disabled]="corTextoAuto"
                                 (valueChange)="deselecionarPaleta(); enviarParaPreview()"></kendo-colorpicker>
              <button class="btn btn-sm ml-2"
                      [ngClass]="{'btn-outline-primary': corTextoAuto, 'btn-outline-secondary': !corTextoAuto}"
                      (click)="toggleCorTextoAuto()"
                      [title]="corTextoAuto ? 'Editar cor manualmente' : 'Usar cor automática'">
                <i class="fas mr-1" [ngClass]="{'fa-pencil-alt': corTextoAuto, 'fa-magic': !corTextoAuto}"></i>
                {{corTextoAuto ? 'Editar' : 'Auto'}}
              </button>
            </div>
            <small class="form-text mt-2" [ngClass]="{'text-success': corTextoAuto, 'text-muted': !corTextoAuto}">
              {{corTextoAuto ? 'Cor calculada automaticamente com base no fundo' : 'Títulos, textos e ofertas'}}
            </small>
          </div>

          <!-- Cor de Fundo dos Cards -->
          <div class="color-control">
            <label class="font-weight-bold">Cor de Fundo dos Cards</label>
            <div class="mt-2">
              <kendo-colorpicker class="color-picker-compact" [(value)]="bioPagina.corFundoCard" [format]="'hex'"
                                 (valueChange)="deselecionarPaleta(); atualizarCorTextoAuto(); enviarParaPreview()"></kendo-colorpicker>
            </div>
            <small class="form-text text-muted mt-2">Fundo dos cards de link e oferta</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Estilo -->
    <div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title mb-3">
          <i class="fas fa-sliders-h text-primary mr-2"></i>
          Estilo
        </h5>

        <!-- Border Radius -->
        <div class="style-control mb-4">
          <label class="font-weight-bold">Arredondamento</label>
          <small class="text-muted d-block mb-2">Curvatura dos cards ({{bioPagina.borderRadius}}px)</small>
          <input type="range" class="form-control-range" min="0" max="24" step="1"
                 [(ngModel)]="bioPagina.borderRadius"
                 (ngModelChange)="enviarParaPreview()" />
          <div class="d-flex justify-content-between mt-1">
            <small class="text-muted">0px</small>
            <small class="text-muted">24px</small>
          </div>
        </div>

        <!-- Fonte -->
        <div class="style-control mb-4">
          <label class="font-weight-bold">Fonte</label>
          <small class="text-muted d-block mb-2">Tipografia da página</small>
          <select class="form-control" [(ngModel)]="bioPagina.fonte"
                  (ngModelChange)="enviarParaPreview()">
            <option *ngFor="let f of fontesDisponiveis" [ngValue]="f.value">{{f.label}}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Acessibilidade -->
    <div class="card mb-3">
      <div class="card-body">
        <h5 class="card-title mb-3">
          <i class="fas fa-universal-access text-primary mr-2"></i>
          Acessibilidade
        </h5>
        <div class="acessibilidade-lista">
          <div class="acessibilidade-item"
               *ngFor="let check of verificacoesAcessibilidade"
               [ngClass]="{'check-passa': check.passa, 'check-falha': !check.passa}">
            <span class="check-icon">
              <i class="fas" [ngClass]="{'fa-check-circle': check.passa, 'fa-times-circle': !check.passa}"></i>
            </span>
            <span class="check-label">{{check.label}}</span>
            <span class="check-swatches">
              <span class="mini-swatch" [style.backgroundColor]="check.cor1"></span>
              <span class="mini-swatch" [style.backgroundColor]="check.cor2"></span>
            </span>
            <span class="check-ratio">{{check.ratio}}:1</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Barra Sticky -->
    <div class="sticky-bottom-bar">
      <button class="btn btn-success btn-salvar" (click)="salvar()" [disabled]="salvando"
              [ngClass]="{'btn-pulse': temAlteracoesPendentes}">
        <i class="fas fa-save mr-1" *ngIf="!salvando"></i>
        <i class="fas fa-spinner fa-spin mr-1" *ngIf="salvando"></i>
        {{salvando ? 'Salvando...' : 'Salvar'}}
      </button>
      <button class="btn btn-outline-secondary" (click)="resetar()">
        <i class="fas fa-undo mr-1"></i> Resetar
      </button>
    </div>
  </div>

  <!-- Coluna direita: Preview -->
  <div class="preview-panel">
    <!-- Preview Header -->
    <div class="preview-header">
      <button class="btn btn-sm btn-outline-secondary" (click)="toggleControles()">
        <i class="fas" [ngClass]="{'fa-chevron-left': mostrarControles, 'fa-chevron-right': !mostrarControles}"></i>
        {{mostrarControles ? 'Esconder' : 'Mostrar'}}
      </button>
      <span class="preview-title">Preview em tempo real</span>
      <div class="btn-group">
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'mobile', 'btn-outline-primary': modoPreview !== 'mobile'}"
                (click)="modoPreview = 'mobile'">
          <i class="fas fa-mobile-alt mr-1"></i> Mobile
        </button>
        <button class="btn btn-sm"
                [ngClass]="{'btn-primary': modoPreview === 'desktop', 'btn-outline-primary': modoPreview !== 'desktop'}"
                (click)="modoPreview = 'desktop'">
          <i class="fas fa-desktop mr-1"></i> Desktop
        </button>
      </div>
    </div>

    <!-- Frame do celular -->
    <div class="phone-frame" [ngClass]="{'desktop-frame': modoPreview === 'desktop'}">
      <div class="phone-notch" *ngIf="modoPreview === 'mobile'"></div>
      <div class="phone-screen">
        <iframe *ngIf="urlPreview"
                #iframePreview
                [src]="urlPreview"
                class="preview-iframe"
                frameborder="0"
                scrolling="yes">
        </iframe>
        <div *ngIf="!urlPreview" class="no-preview">
          <i class="fas fa-eye-slash fa-2x text-muted mb-2"></i>
          <p class="text-muted">Configure o slug para visualizar o preview</p>
        </div>
      </div>
      <div class="phone-home-bar" *ngIf="modoPreview === 'mobile'"></div>
    </div>

    <div class="mt-3 text-center" *ngIf="urlPreview">
      <button class="btn btn-outline-secondary btn-sm" (click)="abrirEmNovaAba()">
        <i class="fas fa-external-link-alt mr-1"></i> Abrir Página
      </button>
    </div>
  </div>
</div>
